import React from 'react';
import {connect} from 'react-redux';
import {Icon} from '@material-ui/core';
import {I18n} from 'react-redux-i18n';
import {openSnapshotsCarousel} from '../DVRSnapshotsActions';

class DVRSnapshot extends React.Component {
  handleSnapshotInfoMessage = () => {
    const {isEnabled, hasBlackImage} = this.props.channel;

    if (isEnabled === false) {
      return (
        <div className="dvrcard__cameraerror-iconmsg">
          <Icon className="dvrcard__cameraerror-icon">warning</Icon>
          <span>{I18n.t('page.dvrsnapshots.snapshotInfo.notEnabled')}</span>
        </div>
      );
    } else if (hasBlackImage === true) {
      return (
        <div className="dvrcard__cameraerror-iconmsg">
          <Icon className="dvrcard__cameraerror-icon">warning</Icon>
          <span>{I18n.t('page.dvrsnapshots.snapshotInfo.blackImage')}</span>
        </div>
      );
    }
    return null;
  }

  handleOpenSnapshotsCarousel = activeChannelName => () => {
    this.props.openSnapshotsCarousel(activeChannelName);
  }

  render() {
    const {id} = this.props;

    return (
      <div>
        <span id={`${id}Label`} className="dvrcard__cameralabel">
          {I18n.t(`page.dvrsnapshots.channels.${this.props.channel.name}`)}
        </span>

        <div className="dvrcard__camera">
          <img
            id={`${id}Image`}
            src={this.props.channel.image}
            onClick={this.handleOpenSnapshotsCarousel(this.props.channel.name)}
            title={I18n.t(`page.dvrsnapshots.channels.${this.props.channel.name}`)}
            alt=""
            className="dvrcard__snapshotAspectRatio"
          />
        </div>

        <div
          id={`${id}Message`}
          className="dvrcard__cameraerror"
        >
          {this.handleSnapshotInfoMessage()}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return state;
};

export default connect(mapStateToProps, {openSnapshotsCarousel})(DVRSnapshot);
